export const USDL_CONST = {
  ID: 'USDL_age_verification',
  NAME: 'USDL Age Verification',
  KEYWORDS: ['age', 'verification', 'usdl'],
  INFO:
    'Age verification functionality using United States Driving License to verify the age of the customer and controls the sale of pre configured products.',
};

export type USDLProductConfig = {
  minAge: number;
  maxAmount: number;
};

export interface USDLPluginConfiguration {
  products: Record<number, USDLProductConfig>;
  productGroups: Record<number, USDLProductConfig>;
}
